export function calculateLengthPerWord(totalLengthInSeconds: number, wordCount: number) {
  return totalLengthInSeconds / wordCount;
}
